import { render, staticRenderFns } from "./a-link-minimal.vue?vue&type=template&id=481f264a&"
import script from "./a-link-minimal.vue?vue&type=script&lang=js&"
export * from "./a-link-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports